<template>
  <div id="quantum-safe-apps">
    <b-container class="container--max-lg">
      <div class="mb-3">
        <h1>{{ $t("lang.label_quantumSafeApps") }}</h1>
      </div>
      <div class="c-dashboard__card">
        <div class="mb-3">
          <router-link class="c-link" to="/dashboard">
            <svg viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.393 19.509L9.464 12l8.929-7.509a.5.5 0 0 0 .06-.704l-1.287-1.531a.5.5 0 0 0-.704-.06L6.168 10.851a1.5 1.5 0 0 0 0 2.296l10.294 8.657a.5.5 0 0 0 .704-.06l1.287-1.532a.5.5 0 0 0-.06-.704z"
                  id="ic-angle-left_svg__a"
                />
              </defs>
              <use fill="currentColor" xlink:href="#ic-angle-left_svg__a" transform="translate(-5 -2)" fill-rule="evenodd" />
            </svg>
            <span>{{ $t("lang.label_back") }}</span></router-link
          >
        </div>
        <b-card class="mb-3 hover-image-card">
          <b-row>
            <b-col cols="5">
              <div class="mt-3 mb-5">
                <b-img fluid center src="images/layout/sunray-default256.png"></b-img>
              </div>

              <div class="mb-6 text-center">
                <div v-if="!isMobileOS" class="c-topbar__action--certificate">
                  <b-button :disabled="!isWindows()" variant="primary" :href="prepareDownload(null, 'Sunray')" target="_blank" download>
                    <mtg-icon icon="ic-download" viewBox="0 0 24 24"></mtg-icon>
                    <span>{{ $t("lang.label_certificate_download") }}</span>
                  </b-button>
                </div>
                <div v-else>
                  Mobile Version coming soon...
                </div>

                <a class="other-platforms" @click="showModal('Sunray')">
                  <br />
                  {{ $t("lang.label_quantumSafeApps_otherPlatforms") }}</a
                >
              </div>

              <div v-if="!isMobileOS">
                <i>{{ $t("lang.label_quantumSafeApps_checksum") }} </i>
                <div>{{ sunrayChecksum() }}</div>
              </div>
              <div v-else>
                There is no mobile version. You can download the available desktop versions by clicking on "Other Platforms"
              </div>
            </b-col>

            <b-col cols="7">
              <b-card-title class="text-left"> {{ $t("lang.label_quantumSafeApps_sunray") }}</b-card-title>
              <b-card-text> {{ $t("lang.info_quantumSafeApps_sunray_howto") }}</b-card-text>
              <b-card-text> {{ $t("lang.info_quantumSafeApps_sunray_moreInfo") }}</b-card-text>
              <b-card-text>
                {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunray1") }} <a class="hover-item-card" @click="scrollTo('pkcs11')">{{ $t("lang.info_quantumSafeApps_download_here") }}</a
                >. {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunray2") }}
                <router-link :to="{ name: 'quantum-safe-apps-instructions', params: { openTab: 'sunray' } }">{{ $t("lang.info_quantumSafeApps_download_here") }}</router-link>
                .
              </b-card-text>
              <b-card-text>
                {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunray3") }}
                <router-link :to="{ name: 'login-and-registration' }">https://pqc-pki.mtg.de</router-link>
                {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunray4") }}
              </b-card-text>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mb-3 hover-image-card">
          <b-row>
            <b-col cols="7">
              <b-card-title class="text-left"> {{ $t("lang.label_quantumSafeApps_sunbeam") }}</b-card-title>
              <b-card-text> {{ $t("lang.info_quantumSafeApps_sunbeam_howto") }}</b-card-text>
              <b-card-text> {{ $t("lang.info_quantumSafeApps_sunbeam_moreInfo1") }}</b-card-text>
              <b-card-text>
                {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunbeam1") }} <a class="hover-item-card" @click="scrollTo('pkcs11')">{{ $t("lang.info_quantumSafeApps_download_here") }}</a
                >. {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunbeam2") }}
                <router-link :to="{ name: 'quantum-safe-apps-instructions', params: { openTab: 'sunbeam' } }">{{ $t("lang.info_quantumSafeApps_download_here") }}</router-link>
                .
              </b-card-text>
              <b-card-text>
                {{ $t("lang.info_quantumSafeApps_use_pkcs11_sunbeam3") }}
              </b-card-text>
            </b-col>
            <b-col cols="5">
              <div class="mt-3 mb-5">
                <b-img fluid center src="images/layout/sunbeam-default256.png"></b-img>
              </div>

              <div class="mb-6 text-center">
                <div v-if="!isMobileOS" class="c-topbar__action--certificate">
                  <b-button :disabled="!isWindows()" variant="primary" :href="prepareDownload(null, 'Sunbeam')" target="_blank" download>
                    <mtg-icon icon="ic-download" viewBox="0 0 24 24"></mtg-icon>
                    <span>{{ $t("lang.label_certificate_download") }}</span>
                  </b-button>
                </div>
                <div v-else>
                  Mobile Version coming soon...
                </div>

                <a class="other-platforms" @click="showModal('Sunbeam')">
                  <br />
                  {{ $t("lang.label_quantumSafeApps_otherPlatforms") }}</a
                >
              </div>

              <div v-if="!isMobileOS">
                <i>{{ $t("lang.label_quantumSafeApps_checksum") }} </i>
                <div>{{ sunbeamChecksum() }}</div>
              </div>
              <div v-else>
                There is no mobile version. You can download the available desktop versions by clicking on "Other Platforms"
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card ref="pkcs11" class="mb-3">
          <b-row>
            <b-col cols="5">
              <div class="mt-5 mb-6">
                <b-img fluid center src="images/layout/illu-post-quantum-certificate.png"></b-img>
              </div>

              <div class="space-button-checksum text-center">
                <div v-if="!isMobileOS" class="c-topbar__action--certificate">
                  <b-button :disabled="!isWindows()" variant="primary" :href="prepareDownload(null, 'PKCS11')" target="_blank" download>
                    <mtg-icon icon="ic-download" viewBox="0 0 24 24"></mtg-icon>
                    <span>{{ $t("lang.label_certificate_download") }}</span>
                  </b-button>
                </div>
                <div v-else>
                  Mobile Version coming soon...
                </div>

                <a class="other-platforms" @click="showModal('PKCS11')">
                  <br />
                  {{ $t("lang.label_quantumSafeApps_otherPlatforms") }}</a
                >
              </div>

              <div v-if="!isMobileOS">
                <i>{{ $t("lang.label_quantumSafeApps_checksum") }} </i>
                <div>{{ pkcs11Checksum() }}</div>
              </div>
              <div v-else>
                There is no mobile version. You can download the available desktop versions by clicking on "Other Platforms"
              </div>
            </b-col>

            <b-col cols="7">
              <b-card-title class="text-left"> {{ $t("lang.label_quantumSafeApps_pkcs11") }}</b-card-title>
              <b-card-text> {{ $t("lang.info_quantumSafeApps_pkcs11_howto") }}</b-card-text>
              <b-card-text>
                {{ $t("lang.info_quantumSafeApps_pkcs11_installationInstructions") }}
                {{ $t("lang.info_quantumSafeApps_pkcs11_installationInstructions_sunray") }}
                <router-link :to="{ name: 'quantum-safe-apps-instructions', params: { openTab: 'sunray' } }">{{ $t("lang.info_quantumSafeApps_download_here") }}</router-link>
                {{ $t("lang.info_quantumSafeApps_pkcs11_installationInstructions_sunbeam") }}
                <router-link :to="{ name: 'quantum-safe-apps-instructions', params: { openTab: 'sunbeam' } }">{{ $t("lang.info_quantumSafeApps_download_here") }} </router-link>
                .
              </b-card-text>
              <b-card-text> {{ $t("lang.info_quantumSafeApps_pkcs11_MoreInfo") }}</b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-container>
    <b-modal ref="bv-modal-download" centered hide-footer>
      <template v-slot:modal-title>
        {{ $t("lang.label_quantumSafeApps_otherPlatforms") }}
      </template>
      <div class="d-block text-center">
        {{ $t("lang.label_quantumSafeApps_otherPlatforms_question1") }}<strong>{{ this.selectedApp }}</strong
        >{{ $t("lang.label_quantumSafeApps_otherPlatforms_question2") }}
      </div>
      <b-button class="mt-3 mb-1" block :href="downloadApp('Windows', selectedApp)" target="_blank" download> {{ $t("lang.label_quantumSafeApps_otherPlatforms_win") }}</b-button>

      <b-row>
        <b-col cols="4" class="ml-3">
          <i>{{ $t("lang.label_quantumSafeApps_checksum") }} </i>
        </b-col>
        <b-col cols="8" class="mx-n5" style="word-break: break-word">
          <div v-if="this.selectedApp === 'Sunray'">{{ sunrayChecksum_WIN }}</div>
          <div v-else-if="this.selectedApp === 'Sunbeam'">{{ sunbeamChecksum_WIN }}</div>
          <div v-else-if="this.selectedApp === 'PKCS11'">{{ pkcs11Checksum_WIN }}</div>
        </b-col>
      </b-row>

      <b-button class="mt-3" disabled block :href="downloadApp('Mac', selectedApp)" target="_blank" download> {{ $t("lang.label_quantumSafeApps_otherPlatforms_mac") }}</b-button>
      <b-row>
        <b-col cols="4" class="ml-3">
          <i>{{ $t("lang.label_quantumSafeApps_checksum") }} </i>
        </b-col>
        <b-col cols="8" class="mx-n5" style="word-break: break-word">
          <div v-if="this.selectedApp === 'Sunray'">{{ sunrayChecksum_MAC }}</div>
          <div v-else-if="this.selectedApp === 'Sunbeam'">{{ sunbeamChecksum_MAC }}</div>
          <div v-else-if="this.selectedApp === 'PKCS11'">{{ pkcs11Checksum_MAC }}</div>
        </b-col>
      </b-row>

      <b-button class="mt-3" disabled block :href="downloadApp('Linux', selectedApp)" target="_blank" download> {{ $t("lang.label_quantumSafeApps_otherPlatforms_linux") }}</b-button>
      <b-row>
        <b-col cols="4" class="ml-3">
          <i> {{ $t("lang.label_quantumSafeApps_checksum") }} </i>
        </b-col>
        <b-col cols="8" class="mx-n5" style="word-break: break-word">
          <div v-if="this.selectedApp === 'Sunray'">{{ sunrayChecksum_Linux }}</div>
          <div v-else-if="this.selectedApp === 'Sunbeam'">{{ sunbeamChecksum_Linux }}</div>
          <div v-else-if="this.selectedApp === 'PKCS11'">{{ pkcs11Checksum_Linux }}</div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped>
.hover-image-card img:hover {
  cursor: pointer;
}

.hover-item-card {
  cursor: pointer;
  text-decoration: underline;
}

.space-button-checksum {
  margin-bottom: 4rem;
}

.other-platforms {
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
export default {
  data() {
    return {
      isMobile: false,
      selectedApp: "",
      sunrayChecksum_WIN: "8d3dfae3fe2f1009f7273b0978de5b5fe9379af6bac8106e961d0ca91e0075e5",
      sunrayChecksum_MAC: "Coming soon",
      sunrayChecksum_Linux: "Coming soon",
      sunbeamChecksum_WIN: "493b8428ecc32c571902f308aa98696c9f1eadf9c372754379495a73bbc934fe",
      sunbeamChecksum_MAC: "Coming soon",
      sunbeamChecksum_Linux: "Coming soon",
      pkcs11Checksum_WIN: "0b10cbb78034ccb91166068882c5ac2a4b83c6b57a4d8ee32f524b6bf043e61e",
      pkcs11Checksum_MAC: "Coming soon", //d4aa41695fa82306e2e6b1332b0920fa60b3c51503ac262923ee7d1cf0ecf7d2
      pkcs11Checksum_Linux: "Coming soon"
    };
  },
  methods: {
    showModal(app) {
      this.selectedApp = app;
      this.$refs["bv-modal-download"].show();
    },
    scrollTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    prepareDownload(platform, app) {
      if (platform === null) {
        if (this.isWindows()) {
          platform = "Windows";
        } else if (this.isMac()) {
          platform = "Mac";
        } else if (this.isLinux()) {
          platform = "Linux";
        }
      }
      return this.downloadApp(platform, app);
    },
    downloadApp(platform, app) {
      if (platform === "Windows") {
        if (app === "Sunray") {
          return "https://pqc-download.mtg.de/pqc/sunray-US.win64.installer.exe";
        } else if (app === "Sunbeam") {
          return "https://pqc-download.mtg.de/pqc/sunbeam-US.win64.installer.exe";
        } else {
          return "https://pqc-download.mtg.de/pqc/mtg-pqc-pkcs11.win64.dll";
        }
      } else if (platform === "Mac") {
        if (app === "Sunray") {
          return "https://pqc-download.mtg.de/pqc/sunray-US.mac.dmg";
        } else if (app === "Sunbeam") {
          return "https://pqc-download.mtg.de/pqc/sunbeam-US.mac.dmg";
        } else {
          return "https://pqc-download.mtg.de/pqc/mtg-pqc-pkcs11.mac.dylib";
        }
      } else if (platform === "Linux") {
        if (app === "Sunray") {
          return "https://pqc-download.mtg.de/pqc/";
        } else if (app === "Sunbeam") {
          return "https://pqc-download.mtg.de/pqc/";
        } else {
          return "https://pqc-download.mtg.de/pqc/";
        }
      }
    },
    isWindows() {
      return navigator.userAgent.includes("Win");
    },
    isMac() {
      return navigator.userAgent.includes("Intel Mac");
    },
    isLinux() {
      return navigator.userAgent.includes("Linux") && !navigator.userAgent.includes("Android");
    },
    sunrayChecksum() {
      if (navigator.userAgent.includes("Win")) {
        return this.sunrayChecksum_WIN;
      } else if (this.isMac()) {
        return this.sunrayChecksum_MAC;
      } else if (this.isLinux()) {
        return this.sunrayChecksum_Linux;
      }
    },
    sunbeamChecksum() {
      if (navigator.userAgent.includes("Win")) {
        return this.sunbeamChecksum_WIN;
      } else if (this.isMac()) {
        return this.sunbeamChecksum_MAC;
      } else if (this.isLinux()) {
        return this.sunbeamChecksum_Linux;
      }
    },
    pkcs11Checksum() {
      if (navigator.userAgent.includes("Win")) {
        return this.pkcs11Checksum_WIN;
      } else if (this.isMac()) {
        return this.pkcs11Checksum_MAC;
      } else if (this.isLinux()) {
        return this.pkcs11Checksum_Linux;
      }
    }
  },
  computed: {
    isMobileOS() {
      return !(this.isWindows() || this.isMac() || this.isLinux());
    }
  }
};
</script>
